import styled from 'styled-components';

const SideBar = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 1.5rem;
`;

export default SideBar;
